import { Account } from '../../types';
import AccountTable from './TableView/AccountTable';
import AddAccountButton from '../../creation/components/AddAccountButton';

interface Props {
  accounts: Account[];
  onActivated: () => void;
  onCreate: () => void;
}

export default function TableView({ accounts, onActivated, onCreate }: Props) {
  return (
    <>
      <AccountTable
        accounts={accounts}
        onActivated={onActivated}
      />
      <AddAccountButton onClick={onCreate} />
    </>
  );
}
